import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';
import moment from 'moment';

const BookingCancel = ({
  isOpen,
  toggle,
  reload,
  bookingId,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [isOpenBookingCancelSuccessModal, setIsOpenBookingCancelSuccessModal] = useState(false);
  const [isOpenBookingCancelFailModal, setIsOpenBookingCancelFailModal] = useState(false);
  const [ messageBookingCancelFail, setMessageBookingCancelFail ] = useState('');
  const [ bookingSelectItem, setBookingSelectItem ] = useState({
    roomName: '',
    userName: '',
    checkinAt: '',
    checkoutAt: '',
  });

  const cancelBooking = async () => {
    try {
      setIsLoading(true);
      await api.cancelBooking({bookingId});
      toggle();
      setIsOpenBookingCancelSuccessModal(true);
      setTimeout(() => {
        setIsOpenBookingCancelSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      toggle();
      if (!error.response) setMessageBookingCancelFail(error.message);
      else setMessageBookingCancelFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenBookingCancelFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const selectBooking = async () => {
      try {
        const res = await api.selectBooking({bookingId});
        setBookingSelectItem({
          roomName: res.data.room.name,
          userName: res.data.user.name,
          checkinAt: moment(res.data.checkin_at).format('YYYY-MM-DD HH:mm'),
          checkoutAt: moment(res.data.checkout_at).format('YYYY-MM-DD HH:mm'),
        });
        // setBookingSelectItem({
        //   roomName: '101',
        //   userName: '홍길동',
        //   checkinAt: '21.04.05',
        //   checkoutAt: '21.04.05',
        // });
      } catch (error) {
        throw error;
      }
    };
    if (bookingId) selectBooking();
  }, [bookingId, isOpen]);

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          <p className='mb-0 mt-0'>
            {t('confirm_message.delete_booking')}<br/>
          </p>
          <div className='booking-cancel-content'>
            <p>{`${t('data_column.room_name')}: ${bookingSelectItem.roomName || '-'}`}</p>
            <p>{`${t('data_column.user_name')}: ${bookingSelectItem.userName || '-'}`}</p>
            <p>{`${t('data_column.checkin_at')}: ${bookingSelectItem.checkinAt || '-'}`}</p>
            <p>{`${t('data_column.checkout_at')}: ${bookingSelectItem.checkoutAt || '-'}`}</p>
          </div>
          <button className='modal-btn-cancel' onClick={() => toggle()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.cancel')}
          </button>
          <button className='modal-btn-confirm' onClick={cancelBooking}>
            <FontAwesomeIcon icon={faSave} style={{paddingRight:'3px'}}/>{t('button.ok')}
          </button>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenBookingCancelSuccessModal}
        toggle={() => setIsOpenBookingCancelSuccessModal(!isOpenBookingCancelSuccessModal)}
        message={t('success_message.delete_booking')}
      />
      <ResponseFailModal
        isOpen={isOpenBookingCancelFailModal}
        toggle={() => setIsOpenBookingCancelFailModal(!isOpenBookingCancelFailModal)}
        message={messageBookingCancelFail || t('error_message.delete_booking')}
      />
    </Fragment>
  );
}

export default BookingCancel;